export default function refreshToken() {
  return true;
}
